{
  "en": {
    "{0} {1} готовы": "{0} {1} ready",
    "{0} варианта в заказе": "{0} options per order",
    "{0} и ещё {1}": "{0} and {1} more",
    "{0} разных рилсов": "{0} different reels",
    "{0} разных сюжетов с вами за один заказ": "{0} different stories starring you in one order",
    "{0} рилсов сразу": "{0} reels at once",
    "{0} фото{1}": "{0} photos{1}",
    "· скидка {0}": "· {0} off",
    "Блюдо крупно, при дневном свете": "The dish up close, in daylight",
    "Бот уже прислал их в чат, в отдельную тему.": "The bot has already sent them to the chat, in a separate topic.",
    "В рилс войдут первые {0} фото": "The reel will use the first {0} photos",
    "Варианты собраны": "Options assembled",
    "Во всех шаблонах": "In all templates",
    "Вы в истории шаблона «{0}»": "You in the story of the “{0}” template",
    "Вы в кадре": "You are in the frame",
    "Вы в кино": "You in the movies",
    "Вы в сюжете": "You are in the story",
    "Выберите, кто в кадре": "Choose who is in the frame",
    "Выбрать несколько шаблонов": "Select several templates",
    "Главный герой": "Lead role",
    "Дальше": "Next",
    "Дальше ·": "Next ·",
    "Десять разных сюжетов с вами за один заказ": "Ten different stories starring you in one order",
    "Для этого ряда ещё варианты недоступны": "More options are not available for this row",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "Added {0} of {1}: the template takes up to {2} photos",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "The extra order is not confirmed. Tapping again will check the same request.",
    "Другой шаблон": "Another template",
    "Ещё 3 варианта": "3 more options",
    "Ещё варианты можно добавить в конце ряда.": "You can add more options at the end of the row.",
    "Загружаем фото": "Uploading photos",
    "Загрузите {0} фото{1}": "Upload {0} photos{1}",
    "Загрузите ещё {0} фото{1}": "Upload {0} more photos{1}",
    "Загрузите фото{0}": "Upload a photo{0}",
    "Заменить фото": "Replace the photo",
    "Играет в шаблонах: {0}": "Plays in templates: {0}",
    "Камера · снимки подряд": "Camera · shots in a row",
    "Кто будет в истории шаблона": "Who will be in the template’s story",
    "Кто будет во всех десяти роликах": "Who will be in all ten clips",
    "Люди в сюжете": "People are in the story",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "You can leave the screen: the bot will send the finished clips to the chat.",
    "Монтаж и музыка": "Editing and music",
    "Музыка и монтаж из шаблона": "Music and editing from the template",
    "Музыка и монтаж уже в шаблоне": "Music and editing are already in the template",
    "Нажмите, чтобы открыть шаблон": "Tap to open the template",
    "Нажмите, чтобы отметить шаблон": "Tap to select the template",
    "Не получилось собрать рилс": "Could not make the reel",
    "Не хватает Circle. Пополните баланс": "Not enough Circle. Top up your balance",
    "Не хватает {0} C. Пополните баланс": "{0} C short. Top up your balance",
    "От трёх шаблонов скидка 20%": "20% off from three templates",
    "Открыть шаблон": "Open template",
    "Отметить": "Select",
    "Отметьте ещё один шаблон": "Select one more template",
    "Отметьте шаблоны": "Select templates",
    "Отметьте шаблоны: от трёх скидка 20%": "Select templates: 20% off from three",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "The bundle is made separately: it already has 10 reels",
    "По {0} варианта": "{0} options each",
    "Пример:": "Example:",
    "Рилс с вами": "Reels with you",
    "Рилсы собраны": "Reels assembled",
    "Роль «{0}» пока недоступна": "The “{0}” role is not available yet",
    "Светлые кадры, каждое место целиком": "Bright shots, each place in full",
    "Скидка 20% за набор": "20% off for the set",
    "Смонтировано": "Edited",
    "Смотреть:": "Watch:",
    "Снимаем сцены": "Shooting the scenes",
    "Снять отметку": "Deselect",
    "Собираем": "Assembling",
    "Собираем {0} {1}": "Assembling {0} {1}",
    "Собираем рилс": "Making the reel",
    "Собираем рилсы": "Making the reels",
    "Создать {0} {1} · {2}": "Create {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Create {0} reels · {1}",
    "Создать · {0}": "Create · {0}",
    "Ставим вас в сюжет": "Placing you in the story",
    "Ставим людей в сюжет": "Placing people in the story",
    "Стиль «{0}» ·": "Style “{0}” ·",
    "Сцены сняты": "Scenes shot",
    "Товар целиком, на чистом фоне, без надписей": "The whole product, on a plain background, no text",
    "Только для этого рилса": "Only for this reel",
    "Тут откроется тема чата, куда бот прислал рилсы": "This will open the chat topic where the bot sent the reels",
    "У каждого по {0} варианта.": "Each has {0} options.",
    "Удалить из рилса": "Remove from the reel",
    "Удерживайте, чтобы посмотреть пример": "Hold to see an example",
    "Фото блюда": "Dish photos",
    "Фото загружены": "Photos uploaded",
    "Фото места": "Place photos",
    "Фото не прошли проверку": "The photos did not pass the check",
    "Чёткие снимки: лица и детали хорошо видно": "Sharp shots: faces and details are clearly visible",
    "Шаблон «{0}»": "Template “{0}”",
    "Шаблон берёт до {0} фото": "The template takes up to {0} photos",
    "Шаблоны в заказе": "Templates in the order",
    "Этот вариант рилса пока недоступен": "This reel option is not available yet",
    "блюда": "of the dish",
    "в работе": "in progress",
    "вариант": "option",
    "варианта": "options",
    "вариантов": "options",
    "вместо": "instead of",
    "до / после": "before / after",
    "до {0} фото": "up to {0} photos",
    "до {0} фото{1}": "up to {0} photos{1}",
    "из рилса": "from the reel",
    "из шаблона": "from the template",
    "из этого рилса": "from this reel",
    "места": "of the place",
    "музыка и монтаж уже в": "music and editing are already in the",
    "не участвует в этом шаблоне": "is not in this template",
    "от {0} до {1}": "from {0} to {1}",
    "от {0} до {1} фото": "{0} to {1} photos",
    "от {0} до {1} фото{2}": "{0} to {1} photos{2}",
    "по {0}": "{0} each",
    "по {0} варианта каждого шаблона": "{0} options of each template",
    "по сюжету каждого шаблона": "following each template’s story",
    "рилс": "reel",
    "рилс не создан": "the reel was not created",
    "рилса": "reels",
    "рилсов": "reels",
    "рилсы": "reels",
    "роликов": "clips",
    "стиль «{0}»": "style “{0}”",
    "товара": "of the product",
    "фото {0} из {1}": "photo {0} of {1}",
    "шаблон": "template",
    "шаблона": "templates",
    "шаблонах": "templates",
    "шаблоне": "template",
    "шаблонов": "templates",
    "1 ролик": "1 video",
    "По одному ролику": "One video each",
    "По одному ролику каждого шаблона": "One video of each template",
    "Один ролик в заказе": "One video per order",
    "У каждого по одному ролику.": "Each has one video.",
    "Собираем ролик": "Assembling the clip",
    "за ролик": "per video",
    "Снимаем сцену": "Filming the scene",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "You can leave this screen: the bot will send the finished video to the chat.",
    "Ролик готов": "Video ready",
    "Бот уже прислал его в чат, в отдельную тему.": "The bot has already sent it to the chat, in a separate topic."
  },
  "hy": {
    "{0} {1} готовы": "{0} {1} պատրաստ է",
    "{0} варианта в заказе": "Պատվերում՝ {0} տարբերակ",
    "{0} и ещё {1}": "{0} և ևս {1}",
    "{0} разных рилсов": "{0} տարբեր ռիլս",
    "{0} разных сюжетов с вами за один заказ": "Ձեր մասնակցությամբ {0} տարբեր սյուժե մեկ պատվերով",
    "{0} рилсов сразу": "{0} ռիլս միանգամից",
    "{0} фото{1}": "{0} լուսանկար{1}",
    "· скидка {0}": "· զեղչ {0}",
    "Блюдо крупно, при дневном свете": "Ուտեստը մոտիկից, ցերեկային լույսի ներքո",
    "Бот уже прислал их в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է դրանք չատ՝ առանձին թեմայում։",
    "В рилс войдут первые {0} фото": "Ռիլսում կներառվեն առաջին {0} լուսանկարները",
    "Варианты собраны": "Տարբերակները հավաքված են",
    "Во всех шаблонах": "Բոլոր ձևանմուշներում",
    "Вы в истории шаблона «{0}»": "Դուք «{0}» ձևանմուշի պատմության մեջ",
    "Вы в кадре": "Դուք կադրում եք",
    "Вы в кино": "Դուք կինոյում",
    "Вы в сюжете": "Դուք սյուժեում եք",
    "Выберите, кто в кадре": "Ընտրեք, թե ով է կադրում",
    "Выбрать несколько шаблонов": "Ընտրել մի քանի ձևանմուշ",
    "Главный герой": "Գլխավոր հերոս",
    "Дальше": "Հաջորդը",
    "Дальше ·": "Հաջորդը ·",
    "Десять разных сюжетов с вами за один заказ": "Ձեր մասնակցությամբ տասը տարբեր սյուժե մեկ պատվերով",
    "Для этого ряда ещё варианты недоступны": "Այս շարքի համար լրացուցիչ տարբերակներ հասանելի չեն",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "Ավելացվեց {0}-ը {1}-ից․ ձևանմուշը վերցնում է մինչև {2} լուսանկար",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "Լրացուցիչ պատվերը հաստատված չէ։ Կրկին սեղմելը կստուգի նույն հարցումը։",
    "Другой шаблон": "Այլ ձևանմուշ",
    "Ещё 3 варианта": "Եվս 3 տարբերակ",
    "Ещё варианты можно добавить в конце ряда.": "Լրացուցիչ տարբերակներ կարող եք ավելացնել շարքի վերջում։",
    "Загружаем фото": "Վերբեռնում ենք լուսանկարները",
    "Загрузите {0} фото{1}": "Վերբեռնեք {0} լուսանկար{1}",
    "Загрузите ещё {0} фото{1}": "Վերբեռնեք ևս {0} լուսանկար{1}",
    "Загрузите фото{0}": "Վերբեռնեք լուսանկար{0}",
    "Заменить фото": "Փոխել լուսանկարը",
    "Играет в шаблонах: {0}": "Խաղում է ձևանմուշներում՝ {0}",
    "Камера · снимки подряд": "Տեսախցիկ · կադրեր անընդմեջ",
    "Кто будет в истории шаблона": "Ով կլինի ձևանմուշի պատմության մեջ",
    "Кто будет во всех десяти роликах": "Ով կլինի բոլոր տասը տեսահոլովակներում",
    "Люди в сюжете": "Մարդիկ սյուժեում են",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Կարող եք դուրս գալ էկրանից․ բոտը պատրաստ տեսահոլովակները կուղարկի չաթ։",
    "Монтаж и музыка": "Մոնտաժ և երաժշտություն",
    "Музыка и монтаж из шаблона": "Երաժշտությունն ու մոնտաժը՝ ձևանմուշից",
    "Музыка и монтаж уже в шаблоне": "Երաժշտությունն ու մոնտաժն արդեն ձևանմուշում են",
    "Нажмите, чтобы открыть шаблон": "Սեղմեք՝ ձևանմուշը բացելու համար",
    "Нажмите, чтобы отметить шаблон": "Սեղմեք՝ ձևանմուշը նշելու համար",
    "Не получилось собрать рилс": "Չհաջողվեց ստեղծել ռիլսը",
    "Не хватает Circle. Пополните баланс": "Circle-ը բավարար չէ։ Համալրեք հաշվեկշիռը",
    "Не хватает {0} C. Пополните баланс": "Պակասում է {0} C։ Համալրեք հաշվեկշիռը",
    "От трёх шаблонов скидка 20%": "Երեք ձևանմուշից սկսած՝ 20% զեղչ",
    "Открыть шаблон": "Բացել ձևանմուշը",
    "Отметить": "Նշել",
    "Отметьте ещё один шаблон": "Նշեք ևս մեկ ձևանմուշ",
    "Отметьте шаблоны": "Նշեք ձևանմուշները",
    "Отметьте шаблоны: от трёх скидка 20%": "Նշեք ձևանմուշները․ երեքից սկսած՝ 20% զեղչ",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Փաթեթը հավաքվում է առանձին․ դրանում արդեն 10 ռիլս կա",
    "По {0} варианта": "Յուրաքանչյուրը՝ {0} տարբերակ",
    "Пример:": "Օրինակ՝",
    "Рилс с вами": "Ռիլս ձեզ հետ",
    "Рилсы собраны": "Ռիլսերը հավաքված են",
    "Роль «{0}» пока недоступна": "«{0}» դերը դեռ հասանելի չէ",
    "Светлые кадры, каждое место целиком": "Լուսավոր կադրեր, յուրաքանչյուր վայր ամբողջությամբ",
    "Скидка 20% за набор": "Հավաքածուի համար՝ 20% զեղչ",
    "Смонтировано": "Մոնտաժված է",
    "Смотреть:": "Դիտել՝",
    "Снимаем сцены": "Նկարահանում ենք տեսարանները",
    "Снять отметку": "Հանել նշումը",
    "Собираем": "Հավաքում ենք",
    "Собираем {0} {1}": "Հավաքում ենք {0} {1}",
    "Собираем рилс": "Ստեղծում ենք ռիլսը",
    "Собираем рилсы": "Ստեղծում ենք ռիլսերը",
    "Создать {0} {1} · {2}": "Ստեղծել {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Ստեղծել {0} ռիլս · {1}",
    "Создать · {0}": "Ստեղծել · {0}",
    "Ставим вас в сюжет": "Ձեզ տեղադրում ենք սյուժեում",
    "Ставим людей в сюжет": "Մարդկանց տեղադրում ենք սյուժեում",
    "Стиль «{0}» ·": "«{0}» ոճ ·",
    "Сцены сняты": "Տեսարանները նկարահանված են",
    "Товар целиком, на чистом фоне, без надписей": "Ապրանքն ամբողջությամբ, մաքուր ֆոնի վրա, առանց գրությունների",
    "Только для этого рилса": "Միայն այս ռիլսի համար",
    "Тут откроется тема чата, куда бот прислал рилсы": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է ռիլսերը",
    "У каждого по {0} варианта.": "Յուրաքանչյուրն ունի {0} տարբերակ։",
    "Удалить из рилса": "Հեռացնել ռիլսից",
    "Удерживайте, чтобы посмотреть пример": "Պահեք՝ օրինակը դիտելու համար",
    "Фото блюда": "Ուտեստի լուսանկարներ",
    "Фото загружены": "Լուսանկարները վերբեռնված են",
    "Фото места": "Վայրի լուսանկարներ",
    "Фото не прошли проверку": "Լուսանկարները չանցան ստուգումը",
    "Чёткие снимки: лица и детали хорошо видно": "Հստակ կադրեր․ դեմքերն ու մանրամասները լավ երևում են",
    "Шаблон «{0}»": "«{0}» ձևանմուշ",
    "Шаблон берёт до {0} фото": "Ձևանմուշը վերցնում է մինչև {0} լուսանկար",
    "Шаблоны в заказе": "Պատվերի ձևանմուշները",
    "Этот вариант рилса пока недоступен": "Ռիլսի այս տարբերակը դեռ հասանելի չէ",
    "блюда": "ուտեստի",
    "в работе": "ընթացքում",
    "вариант": "տարբերակ",
    "варианта": "տարբերակ",
    "вариантов": "տարբերակ",
    "вместо": "փոխարենը",
    "до / после": "առաջ / հետո",
    "до {0} фото": "մինչև {0} լուսանկար",
    "до {0} фото{1}": "մինչև {0} լուսանկար{1}",
    "из рилса": "ռիլսից",
    "из шаблона": "ձևանմուշից",
    "из этого рилса": "այս ռիլսից",
    "места": "վայրի",
    "музыка и монтаж уже в": "երաժշտությունն ու մոնտաժն արդեն",
    "не участвует в этом шаблоне": "չի մասնակցում այս ձևանմուշին",
    "от {0} до {1}": "{0}-ից {1}",
    "от {0} до {1} фото": "{0}-ից {1} լուսանկար",
    "от {0} до {1} фото{2}": "{0}-ից {1} լուսանկար{2}",
    "по {0}": "յուրաքանչյուրը՝ {0}",
    "по {0} варианта каждого шаблона": "յուրաքանչյուր ձևանմուշից՝ {0} տարբերակ",
    "по сюжету каждого шаблона": "յուրաքանչյուր ձևանմուշի սյուժեով",
    "рилс": "ռիլս",
    "рилс не создан": "ռիլսը չի ստեղծվել",
    "рилса": "ռիլս",
    "рилсов": "ռիլս",
    "рилсы": "ռիլսերը",
    "роликов": "տեսահոլովակ",
    "стиль «{0}»": "«{0}» ոճ",
    "товара": "ապրանքի",
    "фото {0} из {1}": "լուսանկար {0}՝ {1}-ից",
    "шаблон": "ձևանմուշ",
    "шаблона": "ձևանմուշ",
    "шаблонах": "ձևանմուշներում",
    "шаблоне": "ձևանմուշում",
    "шаблонов": "ձևանմուշ",
    "1 ролик": "1 տեսանյութ",
    "По одному ролику": "Մեկական տեսանյութ",
    "По одному ролику каждого шаблона": "Յուրաքանչյուր ձևանմուշից մեկ տեսանյութ",
    "Один ролик в заказе": "Մեկ տեսանյութ պատվերում",
    "У каждого по одному ролику.": "Յուրաքանչյուրը մեկ տեսանյութ ունի։",
    "Собираем ролик": "Հավաքում ենք տեսահոլովակը",
    "за ролик": "մեկ տեսանյութի համար",
    "Снимаем сцену": "Նկարահանում ենք տեսարանը",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Կարող եք լքել էկրանը. բոտը պատրաստի տեսանյութը կուղարկի չաթ։",
    "Ролик готов": "Տեսանյութը պատրաստ է",
    "Бот уже прислал его в чат, в отдельную тему.": "Բոտն արդեն ուղարկել է այն չատ՝ առանձին թեմայում։"
  },
  "es": {
    "{0} {1} готовы": "Listo: {0} {1}",
    "{0} варианта в заказе": "{0} opciones por pedido",
    "{0} и ещё {1}": "{0} y {1} más",
    "{0} разных рилсов": "{0} reels diferentes",
    "{0} разных сюжетов с вами за один заказ": "{0} historias distintas contigo en un solo pedido",
    "{0} рилсов сразу": "{0} reels de una vez",
    "{0} фото{1}": "{0} fotos{1}",
    "· скидка {0}": "· descuento del {0}",
    "Блюдо крупно, при дневном свете": "El plato de cerca, con luz de día",
    "Бот уже прислал их в чат, в отдельную тему.": "El bot ya las envió al chat, en un tema aparte.",
    "В рилс войдут первые {0} фото": "El reel usará las primeras {0} fotos",
    "Варианты собраны": "Opciones listas",
    "Во всех шаблонах": "En todas las plantillas",
    "Вы в истории шаблона «{0}»": "Tú en la historia de la plantilla «{0}»",
    "Вы в кадре": "Estás en el encuadre",
    "Вы в кино": "Tú en el cine",
    "Вы в сюжете": "Ya estás en la historia",
    "Выберите, кто в кадре": "Elige quién aparece en el fotograma",
    "Выбрать несколько шаблонов": "Elegir varias plantillas",
    "Главный герой": "Protagonista",
    "Дальше": "Siguiente",
    "Дальше ·": "Siguiente ·",
    "Десять разных сюжетов с вами за один заказ": "Diez historias distintas contigo en un solo pedido",
    "Для этого ряда ещё варианты недоступны": "No hay más opciones para esta fila",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "Se añadieron {0} de {1}: la plantilla admite hasta {2} fotos",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "El pedido adicional no está confirmado. Al volver a pulsar se comprobará la misma solicitud.",
    "Другой шаблон": "Otra plantilla",
    "Ещё 3 варианта": "3 opciones más",
    "Ещё варианты можно добавить в конце ряда.": "Puedes añadir más opciones al final de la fila.",
    "Загружаем фото": "Subiendo fotos",
    "Загрузите {0} фото{1}": "Sube {0} fotos{1}",
    "Загрузите ещё {0} фото{1}": "Sube {0} fotos más{1}",
    "Загрузите фото{0}": "Sube una foto{0}",
    "Заменить фото": "Cambiar la foto",
    "Играет в шаблонах: {0}": "Aparece en las plantillas: {0}",
    "Камера · снимки подряд": "Cámara · fotos seguidas",
    "Кто будет в истории шаблона": "Quién estará en la historia de la plantilla",
    "Кто будет во всех десяти роликах": "Quién estará en los diez vídeos",
    "Люди в сюжете": "Las personas ya están en la historia",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Puedes salir de la pantalla: el bot enviará los vídeos terminados al chat.",
    "Монтаж и музыка": "Montaje y música",
    "Музыка и монтаж из шаблона": "Música y montaje de la plantilla",
    "Музыка и монтаж уже в шаблоне": "La música y el montaje ya están en la plantilla",
    "Нажмите, чтобы открыть шаблон": "Toca para abrir la plantilla",
    "Нажмите, чтобы отметить шаблон": "Toca para marcar la plantilla",
    "Не получилось собрать рилс": "No se pudo crear el reel",
    "Не хватает Circle. Пополните баланс": "No tienes suficientes Circle. Recarga tu saldo",
    "Не хватает {0} C. Пополните баланс": "Faltan {0} C. Recarga tu saldo",
    "От трёх шаблонов скидка 20%": "20 % de descuento desde tres plantillas",
    "Открыть шаблон": "Abrir plantilla",
    "Отметить": "Marcar",
    "Отметьте ещё один шаблон": "Marca una plantilla más",
    "Отметьте шаблоны": "Marca las plantillas",
    "Отметьте шаблоны: от трёх скидка 20%": "Marca plantillas: desde tres, 20 % de descuento",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "El paquete se crea aparte: ya incluye 10 reels",
    "По {0} варианта": "{0} opciones cada uno",
    "Пример:": "Ejemplo:",
    "Рилс с вами": "Reels contigo",
    "Рилсы собраны": "Reels listos",
    "Роль «{0}» пока недоступна": "El papel «{0}» aún no está disponible",
    "Светлые кадры, каждое место целиком": "Fotos luminosas, cada lugar completo",
    "Скидка 20% за набор": "20 % de descuento por el conjunto",
    "Смонтировано": "Montado",
    "Смотреть:": "Ver:",
    "Снимаем сцены": "Rodando las escenas",
    "Снять отметку": "Desmarcar",
    "Собираем": "Creando",
    "Собираем {0} {1}": "Creando {0} {1}",
    "Собираем рилс": "Creando el reel",
    "Собираем рилсы": "Creando los reels",
    "Создать {0} {1} · {2}": "Crear {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Crear {0} reels · {1}",
    "Создать · {0}": "Crear · {0}",
    "Ставим вас в сюжет": "Te ponemos en la historia",
    "Ставим людей в сюжет": "Ponemos a las personas en la historia",
    "Стиль «{0}» ·": "Estilo «{0}» ·",
    "Сцены сняты": "Escenas rodadas",
    "Товар целиком, на чистом фоне, без надписей": "El producto entero, sobre fondo liso, sin textos",
    "Только для этого рилса": "Solo para este reel",
    "Тут откроется тема чата, куда бот прислал рилсы": "Aquí se abrirá el tema del chat donde el bot envió los reels",
    "У каждого по {0} варианта.": "Cada uno tiene {0} opciones.",
    "Удалить из рилса": "Quitar del reel",
    "Удерживайте, чтобы посмотреть пример": "Mantén pulsado para ver un ejemplo",
    "Фото блюда": "Fotos del plato",
    "Фото загружены": "Fotos subidas",
    "Фото места": "Fotos del lugar",
    "Фото не прошли проверку": "Las fotos no superaron la revisión",
    "Чёткие снимки: лица и детали хорошо видно": "Fotos nítidas: caras y detalles bien visibles",
    "Шаблон «{0}»": "Plantilla «{0}»",
    "Шаблон берёт до {0} фото": "La plantilla admite hasta {0} fotos",
    "Шаблоны в заказе": "Plantillas del pedido",
    "Этот вариант рилса пока недоступен": "Esta opción de reel aún no está disponible",
    "блюда": "del plato",
    "в работе": "en curso",
    "вариант": "opción",
    "варианта": "opciones",
    "вариантов": "opciones",
    "вместо": "en lugar de",
    "до / после": "antes / después",
    "до {0} фото": "hasta {0} fotos",
    "до {0} фото{1}": "hasta {0} fotos{1}",
    "из рилса": "del reel",
    "из шаблона": "de la plantilla",
    "из этого рилса": "de este reel",
    "места": "del lugar",
    "музыка и монтаж уже в": "la música y el montaje ya están en la",
    "не участвует в этом шаблоне": "no participa en esta plantilla",
    "от {0} до {1}": "de {0} a {1}",
    "от {0} до {1} фото": "de {0} a {1} fotos",
    "от {0} до {1} фото{2}": "de {0} a {1} fotos{2}",
    "по {0}": "{0} cada uno",
    "по {0} варианта каждого шаблона": "{0} opciones de cada plantilla",
    "по сюжету каждого шаблона": "según la historia de cada plantilla",
    "рилс": "reel",
    "рилс не создан": "el reel no se creó",
    "рилса": "reels",
    "рилсов": "reels",
    "рилсы": "los reels",
    "роликов": "vídeos",
    "стиль «{0}»": "estilo «{0}»",
    "товара": "del producto",
    "фото {0} из {1}": "foto {0} de {1}",
    "шаблон": "plantilla",
    "шаблона": "plantillas",
    "шаблонах": "plantillas",
    "шаблоне": "plantilla",
    "шаблонов": "plantillas",
    "1 ролик": "1 vídeo",
    "По одному ролику": "Un vídeo cada uno",
    "По одному ролику каждого шаблона": "Un vídeo de cada plantilla",
    "Один ролик в заказе": "Un vídeo por pedido",
    "У каждого по одному ролику.": "Cada uno tiene un vídeo.",
    "Собираем ролик": "Montando el vídeo",
    "за ролик": "por vídeo",
    "Снимаем сцену": "Rodando la escena",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Puedes salir de la pantalla: el bot enviará el vídeo terminado al chat.",
    "Ролик готов": "Vídeo listo",
    "Бот уже прислал его в чат, в отдельную тему.": "El bot ya lo envió al chat, en un tema aparte."
  },
  "de": {
    "{0} {1} готовы": "{0} {1} fertig",
    "{0} варианта в заказе": "{0} Varianten pro Auftrag",
    "{0} и ещё {1}": "{0} und {1} weitere",
    "{0} разных рилсов": "{0} verschiedene Reels",
    "{0} разных сюжетов с вами за один заказ": "{0} verschiedene Storys mit Ihnen in einem Auftrag",
    "{0} рилсов сразу": "{0} Reels auf einmal",
    "{0} фото{1}": "{0} Fotos{1}",
    "· скидка {0}": "· {0} Rabatt",
    "Блюдо крупно, при дневном свете": "Das Gericht in Nahaufnahme, bei Tageslicht",
    "Бот уже прислал их в чат, в отдельную тему.": "Der Bot hat sie bereits in den Chat geschickt, in ein eigenes Thema.",
    "В рилс войдут первые {0} фото": "Ins Reel kommen die ersten {0} Fotos",
    "Варианты собраны": "Varianten fertig",
    "Во всех шаблонах": "In allen Vorlagen",
    "Вы в истории шаблона «{0}»": "Sie in der Story der Vorlage „{0}“",
    "Вы в кадре": "Sie sind im Bild",
    "Вы в кино": "Sie im Film",
    "Вы в сюжете": "Sie sind in der Story",
    "Выберите, кто в кадре": "Wählen Sie, wer im Bild ist",
    "Выбрать несколько шаблонов": "Mehrere Vorlagen auswählen",
    "Главный герой": "Hauptrolle",
    "Дальше": "Weiter",
    "Дальше ·": "Weiter ·",
    "Десять разных сюжетов с вами за один заказ": "Zehn verschiedene Storys mit Ihnen in einem Auftrag",
    "Для этого ряда ещё варианты недоступны": "Für diese Reihe sind keine weiteren Varianten verfügbar",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "{0} von {1} hinzugefügt: Die Vorlage nimmt bis zu {2} Fotos",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "Die Nachbestellung ist nicht bestätigt. Erneutes Tippen prüft dieselbe Anfrage.",
    "Другой шаблон": "Andere Vorlage",
    "Ещё 3 варианта": "3 weitere Varianten",
    "Ещё варианты можно добавить в конце ряда.": "Weitere Varianten können Sie am Ende der Reihe hinzufügen.",
    "Загружаем фото": "Fotos werden hochgeladen",
    "Загрузите {0} фото{1}": "Laden Sie {0} Fotos{1} hoch",
    "Загрузите ещё {0} фото{1}": "Laden Sie {0} weitere Fotos{1} hoch",
    "Загрузите фото{0}": "Laden Sie ein Foto{0} hoch",
    "Заменить фото": "Foto ersetzen",
    "Играет в шаблонах: {0}": "Spielt in den Vorlagen: {0}",
    "Камера · снимки подряд": "Kamera · Aufnahmen hintereinander",
    "Кто будет в истории шаблона": "Wer in der Story der Vorlage ist",
    "Кто будет во всех десяти роликах": "Wer in allen zehn Clips ist",
    "Люди в сюжете": "Personen sind in der Story",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt die fertigen Clips in den Chat.",
    "Монтаж и музыка": "Schnitt und Musik",
    "Музыка и монтаж из шаблона": "Musik und Schnitt aus der Vorlage",
    "Музыка и монтаж уже в шаблоне": "Musik und Schnitt sind schon in der Vorlage",
    "Нажмите, чтобы открыть шаблон": "Tippen, um die Vorlage zu öffnen",
    "Нажмите, чтобы отметить шаблон": "Tippen, um die Vorlage zu markieren",
    "Не получилось собрать рилс": "Das Reel konnte nicht erstellt werden",
    "Не хватает Circle. Пополните баланс": "Nicht genug Circle. Laden Sie Ihr Guthaben auf",
    "Не хватает {0} C. Пополните баланс": "Es fehlen {0} C. Laden Sie Ihr Guthaben auf",
    "От трёх шаблонов скидка 20%": "Ab drei Vorlagen 20 % Rabatt",
    "Открыть шаблон": "Vorlage öffnen",
    "Отметить": "Markieren",
    "Отметьте ещё один шаблон": "Markieren Sie eine weitere Vorlage",
    "Отметьте шаблоны": "Markieren Sie Vorlagen",
    "Отметьте шаблоны: от трёх скидка 20%": "Markieren Sie Vorlagen: ab drei 20 % Rabatt",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Das Paket wird separat erstellt: Es enthält bereits 10 Reels",
    "По {0} варианта": "Je {0} Varianten",
    "Пример:": "Beispiel:",
    "Рилс с вами": "Reels mit Ihnen",
    "Рилсы собраны": "Reels fertig",
    "Роль «{0}» пока недоступна": "Die Rolle „{0}“ ist noch nicht verfügbar",
    "Светлые кадры, каждое место целиком": "Helle Aufnahmen, jeder Ort vollständig",
    "Скидка 20% за набор": "20 % Rabatt für das Set",
    "Смонтировано": "Geschnitten",
    "Смотреть:": "Ansehen:",
    "Снимаем сцены": "Szenen werden gedreht",
    "Снять отметку": "Markierung aufheben",
    "Собираем": "Wird erstellt",
    "Собираем {0} {1}": "{0} {1} werden erstellt",
    "Собираем рилс": "Reel wird erstellt",
    "Собираем рилсы": "Reels werden erstellt",
    "Создать {0} {1} · {2}": "{0} {1} erstellen · {2}",
    "Создать {0} рилсов · {1}": "{0} Reels erstellen · {1}",
    "Создать · {0}": "Erstellen · {0}",
    "Ставим вас в сюжет": "Wir setzen Sie in die Story",
    "Ставим людей в сюжет": "Wir setzen die Personen in die Story",
    "Стиль «{0}» ·": "Stil „{0}“ ·",
    "Сцены сняты": "Szenen gedreht",
    "Товар целиком, на чистом фоне, без надписей": "Das ganze Produkt, auf schlichtem Hintergrund, ohne Schrift",
    "Только для этого рилса": "Nur für dieses Reel",
    "Тут откроется тема чата, куда бот прислал рилсы": "Hier öffnet sich das Chat-Thema, in das der Bot die Reels geschickt hat",
    "У каждого по {0} варианта.": "Jede hat {0} Varianten.",
    "Удалить из рилса": "Aus dem Reel entfernen",
    "Удерживайте, чтобы посмотреть пример": "Gedrückt halten, um ein Beispiel zu sehen",
    "Фото блюда": "Fotos des Gerichts",
    "Фото загружены": "Fotos hochgeladen",
    "Фото места": "Fotos des Ortes",
    "Фото не прошли проверку": "Die Fotos haben die Prüfung nicht bestanden",
    "Чёткие снимки: лица и детали хорошо видно": "Scharfe Aufnahmen: Gesichter und Details gut sichtbar",
    "Шаблон «{0}»": "Vorlage „{0}“",
    "Шаблон берёт до {0} фото": "Die Vorlage nimmt bis zu {0} Fotos",
    "Шаблоны в заказе": "Vorlagen im Auftrag",
    "Этот вариант рилса пока недоступен": "Diese Reel-Variante ist noch nicht verfügbar",
    "блюда": "des Gerichts",
    "в работе": "in Arbeit",
    "вариант": "Variante",
    "варианта": "Varianten",
    "вариантов": "Varianten",
    "вместо": "statt",
    "до / после": "vorher / nachher",
    "до {0} фото": "bis zu {0} Fotos",
    "до {0} фото{1}": "bis zu {0} Fotos{1}",
    "из рилса": "aus dem Reel",
    "из шаблона": "aus der Vorlage",
    "из этого рилса": "aus diesem Reel",
    "места": "des Ortes",
    "музыка и монтаж уже в": "Musik und Schnitt sind schon in der",
    "не участвует в этом шаблоне": "ist nicht Teil dieser Vorlage",
    "от {0} до {1}": "{0} bis {1}",
    "от {0} до {1} фото": "{0} bis {1} Fotos",
    "от {0} до {1} фото{2}": "{0} bis {1} Fotos{2}",
    "по {0}": "je {0}",
    "по {0} варианта каждого шаблона": "je {0} Varianten pro Vorlage",
    "по сюжету каждого шаблона": "nach der Story jeder Vorlage",
    "рилс": "Reel",
    "рилс не создан": "das Reel wurde nicht erstellt",
    "рилса": "Reels",
    "рилсов": "Reels",
    "рилсы": "die Reels",
    "роликов": "Clips",
    "стиль «{0}»": "Stil „{0}“",
    "товара": "des Produkts",
    "фото {0} из {1}": "Foto {0} von {1}",
    "шаблон": "Vorlage",
    "шаблона": "Vorlagen",
    "шаблонах": "Vorlagen",
    "шаблоне": "Vorlage",
    "шаблонов": "Vorlagen",
    "1 ролик": "1 Video",
    "По одному ролику": "Je ein Video",
    "По одному ролику каждого шаблона": "Ein Video pro Vorlage",
    "Один ролик в заказе": "Ein Video pro Bestellung",
    "У каждого по одному ролику.": "Jede hat ein Video.",
    "Собираем ролик": "Clip wird zusammengesetzt",
    "за ролик": "pro Video",
    "Снимаем сцену": "Szene wird gedreht",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Sie können den Bildschirm verlassen: Der Bot schickt das fertige Video in den Chat.",
    "Ролик готов": "Video fertig",
    "Бот уже прислал его в чат, в отдельную тему.": "Der Bot hat es bereits in einem eigenen Thema in den Chat geschickt."
  },
  "fr": {
    "{0} {1} готовы": "Prêt : {0} {1}",
    "{0} варианта в заказе": "{0} options par commande",
    "{0} и ещё {1}": "{0} et {1} de plus",
    "{0} разных рилсов": "{0} reels différents",
    "{0} разных сюжетов с вами за один заказ": "{0} histoires différentes avec vous en une seule commande",
    "{0} рилсов сразу": "{0} reels d’un coup",
    "{0} фото{1}": "{0} photos{1}",
    "· скидка {0}": "· remise de {0}",
    "Блюдо крупно, при дневном свете": "Le plat en gros plan, à la lumière du jour",
    "Бот уже прислал их в чат, в отдельную тему.": "Le bot les a déjà envoyées dans le chat, dans un sujet à part.",
    "В рилс войдут первые {0} фото": "Le reel utilisera les {0} premières photos",
    "Варианты собраны": "Options prêtes",
    "Во всех шаблонах": "Dans tous les modèles",
    "Вы в истории шаблона «{0}»": "Vous dans l’histoire du modèle « {0} »",
    "Вы в кадре": "Vous êtes dans le cadre",
    "Вы в кино": "Vous au cinéma",
    "Вы в сюжете": "Vous êtes dans l’histoire",
    "Выберите, кто в кадре": "Choisissez qui est dans le cadre",
    "Выбрать несколько шаблонов": "Choisir plusieurs modèles",
    "Главный герой": "Rôle principal",
    "Дальше": "Suivant",
    "Дальше ·": "Suivant ·",
    "Десять разных сюжетов с вами за один заказ": "Dix histoires différentes avec vous en une seule commande",
    "Для этого ряда ещё варианты недоступны": "Pas d’autres options pour cette rangée",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "{0} sur {1} ajoutées : le modèle prend jusqu’à {2} photos",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "La commande supplémentaire n’est pas confirmée. Un nouvel appui vérifiera la même demande.",
    "Другой шаблон": "Un autre modèle",
    "Ещё 3 варианта": "3 options de plus",
    "Ещё варианты можно добавить в конце ряда.": "Vous pouvez ajouter d’autres options en fin de rangée.",
    "Загружаем фото": "Envoi des photos",
    "Загрузите {0} фото{1}": "Importez {0} photos{1}",
    "Загрузите ещё {0} фото{1}": "Importez encore {0} photos{1}",
    "Загрузите фото{0}": "Importez une photo{0}",
    "Заменить фото": "Remplacer la photo",
    "Играет в шаблонах: {0}": "Joue dans les modèles : {0}",
    "Камера · снимки подряд": "Caméra · photos à la suite",
    "Кто будет в истории шаблона": "Qui sera dans l’histoire du modèle",
    "Кто будет во всех десяти роликах": "Qui sera dans les dix vidéos",
    "Люди в сюжете": "Les personnes sont dans l’histoire",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Vous pouvez quitter l’écran : le bot enverra les vidéos terminées dans le chat.",
    "Монтаж и музыка": "Montage et musique",
    "Музыка и монтаж из шаблона": "Musique et montage du modèle",
    "Музыка и монтаж уже в шаблоне": "La musique et le montage sont déjà dans le modèle",
    "Нажмите, чтобы открыть шаблон": "Touchez pour ouvrir le modèle",
    "Нажмите, чтобы отметить шаблон": "Touchez pour sélectionner le modèle",
    "Не получилось собрать рилс": "Impossible de créer le reel",
    "Не хватает Circle. Пополните баланс": "Pas assez de Circle. Rechargez votre solde",
    "Не хватает {0} C. Пополните баланс": "Il manque {0} C. Rechargez votre solde",
    "От трёх шаблонов скидка 20%": "20 % de remise dès trois modèles",
    "Открыть шаблон": "Ouvrir le modèle",
    "Отметить": "Sélectionner",
    "Отметьте ещё один шаблон": "Sélectionnez un modèle de plus",
    "Отметьте шаблоны": "Sélectionnez des modèles",
    "Отметьте шаблоны: от трёх скидка 20%": "Sélectionnez des modèles : 20 % de remise dès trois",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Le pack se crée à part : il contient déjà 10 reels",
    "По {0} варианта": "{0} options chacun",
    "Пример:": "Exemple :",
    "Рилс с вами": "Reels avec vous",
    "Рилсы собраны": "Reels prêts",
    "Роль «{0}» пока недоступна": "Le rôle « {0} » n’est pas encore disponible",
    "Светлые кадры, каждое место целиком": "Images lumineuses, chaque lieu en entier",
    "Скидка 20% за набор": "20 % de remise pour la sélection",
    "Смонтировано": "Monté",
    "Смотреть:": "Regarder :",
    "Снимаем сцены": "Tournage des scènes",
    "Снять отметку": "Désélectionner",
    "Собираем": "Création",
    "Собираем {0} {1}": "Création de {0} {1}",
    "Собираем рилс": "Création du reel",
    "Собираем рилсы": "Création des reels",
    "Создать {0} {1} · {2}": "Créer {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Créer {0} reels · {1}",
    "Создать · {0}": "Créer · {0}",
    "Ставим вас в сюжет": "Nous vous plaçons dans l’histoire",
    "Ставим людей в сюжет": "Nous plaçons les personnes dans l’histoire",
    "Стиль «{0}» ·": "Style « {0} » ·",
    "Сцены сняты": "Scènes tournées",
    "Товар целиком, на чистом фоне, без надписей": "Le produit entier, sur fond uni, sans texte",
    "Только для этого рилса": "Seulement pour ce reel",
    "Тут откроется тема чата, куда бот прислал рилсы": "Ici s’ouvrira le sujet du chat où le bot a envoyé les reels",
    "У каждого по {0} варианта.": "Chacun a {0} options.",
    "Удалить из рилса": "Retirer du reel",
    "Удерживайте, чтобы посмотреть пример": "Maintenez pour voir un exemple",
    "Фото блюда": "Photos du plat",
    "Фото загружены": "Photos importées",
    "Фото места": "Photos du lieu",
    "Фото не прошли проверку": "Les photos n’ont pas passé la vérification",
    "Чёткие снимки: лица и детали хорошо видно": "Photos nettes : visages et détails bien visibles",
    "Шаблон «{0}»": "Modèle « {0} »",
    "Шаблон берёт до {0} фото": "Le modèle prend jusqu’à {0} photos",
    "Шаблоны в заказе": "Modèles de la commande",
    "Этот вариант рилса пока недоступен": "Cette option de reel n’est pas encore disponible",
    "блюда": "du plat",
    "в работе": "en cours",
    "вариант": "option",
    "варианта": "options",
    "вариантов": "options",
    "вместо": "au lieu de",
    "до / после": "avant / après",
    "до {0} фото": "jusqu’à {0} photos",
    "до {0} фото{1}": "jusqu’à {0} photos{1}",
    "из рилса": "du reel",
    "из шаблона": "du modèle",
    "из этого рилса": "de ce reel",
    "места": "du lieu",
    "музыка и монтаж уже в": "la musique et le montage sont déjà dans le",
    "не участвует в этом шаблоне": "ne participe pas à ce modèle",
    "от {0} до {1}": "de {0} à {1}",
    "от {0} до {1} фото": "de {0} à {1} photos",
    "от {0} до {1} фото{2}": "de {0} à {1} photos{2}",
    "по {0}": "{0} chacun",
    "по {0} варианта каждого шаблона": "{0} options par modèle",
    "по сюжету каждого шаблона": "selon l’histoire de chaque modèle",
    "рилс": "reel",
    "рилс не создан": "le reel n’a pas été créé",
    "рилса": "reels",
    "рилсов": "reels",
    "рилсы": "les reels",
    "роликов": "vidéos",
    "стиль «{0}»": "style « {0} »",
    "товара": "du produit",
    "фото {0} из {1}": "photo {0} sur {1}",
    "шаблон": "modèle",
    "шаблона": "modèles",
    "шаблонах": "modèles",
    "шаблоне": "modèle",
    "шаблонов": "modèles",
    "1 ролик": "1 vidéo",
    "По одному ролику": "Une vidéo chacun",
    "По одному ролику каждого шаблона": "Une vidéo par modèle",
    "Один ролик в заказе": "Une vidéo par commande",
    "У каждого по одному ролику.": "Chacun a une vidéo.",
    "Собираем ролик": "Montage de la vidéo",
    "за ролик": "par vidéo",
    "Снимаем сцену": "Tournage de la scène",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Vous pouvez quitter l’écran : le bot enverra la vidéo terminée dans le chat.",
    "Ролик готов": "Vidéo prête",
    "Бот уже прислал его в чат, в отдельную тему.": "Le bot l’a déjà envoyé dans le chat, dans un sujet à part."
  },
  "pt": {
    "{0} {1} готовы": "Pronto: {0} {1}",
    "{0} варианта в заказе": "{0} opções por pedido",
    "{0} и ещё {1}": "{0} e mais {1}",
    "{0} разных рилсов": "{0} reels diferentes",
    "{0} разных сюжетов с вами за один заказ": "{0} histórias diferentes com você em um só pedido",
    "{0} рилсов сразу": "{0} reels de uma vez",
    "{0} фото{1}": "{0} fotos{1}",
    "· скидка {0}": "· desconto de {0}",
    "Блюдо крупно, при дневном свете": "O prato de perto, com luz do dia",
    "Бот уже прислал их в чат, в отдельную тему.": "O bot já as enviou para o chat, num tópico separado.",
    "В рилс войдут первые {0} фото": "O reel usará as primeiras {0} fotos",
    "Варианты собраны": "Opções prontas",
    "Во всех шаблонах": "Em todos os modelos",
    "Вы в истории шаблона «{0}»": "Você na história do modelo “{0}”",
    "Вы в кадре": "Você está no quadro",
    "Вы в кино": "Você no cinema",
    "Вы в сюжете": "Você está na história",
    "Выберите, кто в кадре": "Escolha quem está no quadro",
    "Выбрать несколько шаблонов": "Escolher vários modelos",
    "Главный герой": "Protagonista",
    "Дальше": "Avançar",
    "Дальше ·": "Avançar ·",
    "Десять разных сюжетов с вами за один заказ": "Dez histórias diferentes com você em um só pedido",
    "Для этого ряда ещё варианты недоступны": "Não há mais opções para esta fileira",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "{0} de {1} adicionadas: o modelo aceita até {2} fotos",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "O pedido adicional não foi confirmado. Tocar de novo verificará a mesma solicitação.",
    "Другой шаблон": "Outro modelo",
    "Ещё 3 варианта": "Mais 3 opções",
    "Ещё варианты можно добавить в конце ряда.": "Você pode adicionar mais opções no fim da fileira.",
    "Загружаем фото": "Enviando fotos",
    "Загрузите {0} фото{1}": "Envie {0} fotos{1}",
    "Загрузите ещё {0} фото{1}": "Envie mais {0} fotos{1}",
    "Загрузите фото{0}": "Envie uma foto{0}",
    "Заменить фото": "Trocar a foto",
    "Играет в шаблонах: {0}": "Atua nos modelos: {0}",
    "Камера · снимки подряд": "Câmera · fotos em sequência",
    "Кто будет в истории шаблона": "Quem estará na história do modelo",
    "Кто будет во всех десяти роликах": "Quem estará nos dez vídeos",
    "Люди в сюжете": "As pessoas estão na história",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Você pode sair da tela: o bot enviará os vídeos prontos no chat.",
    "Монтаж и музыка": "Edição e música",
    "Музыка и монтаж из шаблона": "Música e edição do modelo",
    "Музыка и монтаж уже в шаблоне": "Música e edição já estão no modelo",
    "Нажмите, чтобы открыть шаблон": "Toque para abrir o modelo",
    "Нажмите, чтобы отметить шаблон": "Toque para marcar o modelo",
    "Не получилось собрать рилс": "Não foi possível criar o reel",
    "Не хватает Circle. Пополните баланс": "Circle insuficiente. Recarregue seu saldo",
    "Не хватает {0} C. Пополните баланс": "Faltam {0} C. Recarregue seu saldo",
    "От трёх шаблонов скидка 20%": "20% de desconto a partir de três modelos",
    "Открыть шаблон": "Abrir modelo",
    "Отметить": "Marcar",
    "Отметьте ещё один шаблон": "Marque mais um modelo",
    "Отметьте шаблоны": "Marque os modelos",
    "Отметьте шаблоны: от трёх скидка 20%": "Marque modelos: a partir de três, 20% de desconto",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "O pacote é feito à parte: já tem 10 reels",
    "По {0} варианта": "{0} opções cada",
    "Пример:": "Exemplo:",
    "Рилс с вами": "Reels com você",
    "Рилсы собраны": "Reels prontos",
    "Роль «{0}» пока недоступна": "O papel “{0}” ainda não está disponível",
    "Светлые кадры, каждое место целиком": "Fotos claras, cada local por inteiro",
    "Скидка 20% за набор": "20% de desconto pelo conjunto",
    "Смонтировано": "Editado",
    "Смотреть:": "Assistir:",
    "Снимаем сцены": "Gravando as cenas",
    "Снять отметку": "Desmarcar",
    "Собираем": "Criando",
    "Собираем {0} {1}": "Criando {0} {1}",
    "Собираем рилс": "Criando o reel",
    "Собираем рилсы": "Criando os reels",
    "Создать {0} {1} · {2}": "Criar {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Criar {0} reels · {1}",
    "Создать · {0}": "Criar · {0}",
    "Ставим вас в сюжет": "Colocando você na história",
    "Ставим людей в сюжет": "Colocando as pessoas na história",
    "Стиль «{0}» ·": "Estilo “{0}” ·",
    "Сцены сняты": "Cenas gravadas",
    "Товар целиком, на чистом фоне, без надписей": "O produto inteiro, em fundo liso, sem textos",
    "Только для этого рилса": "Só para este reel",
    "Тут откроется тема чата, куда бот прислал рилсы": "Aqui abrirá o tópico do chat onde o bot enviou os reels",
    "У каждого по {0} варианта.": "Cada um tem {0} opções.",
    "Удалить из рилса": "Remover do reel",
    "Удерживайте, чтобы посмотреть пример": "Segure para ver um exemplo",
    "Фото блюда": "Fotos do prato",
    "Фото загружены": "Fotos enviadas",
    "Фото места": "Fotos do local",
    "Фото не прошли проверку": "As fotos não passaram na verificação",
    "Чёткие снимки: лица и детали хорошо видно": "Fotos nítidas: rostos e detalhes bem visíveis",
    "Шаблон «{0}»": "Modelo «{0}»",
    "Шаблон берёт до {0} фото": "O modelo aceita até {0} fotos",
    "Шаблоны в заказе": "Modelos do pedido",
    "Этот вариант рилса пока недоступен": "Esta opção de reel ainda não está disponível",
    "блюда": "do prato",
    "в работе": "em andamento",
    "вариант": "opção",
    "варианта": "opções",
    "вариантов": "opções",
    "вместо": "em vez de",
    "до / после": "antes / depois",
    "до {0} фото": "até {0} fotos",
    "до {0} фото{1}": "até {0} fotos{1}",
    "из рилса": "do reel",
    "из шаблона": "do modelo",
    "из этого рилса": "deste reel",
    "места": "do local",
    "музыка и монтаж уже в": "música e edição já estão no",
    "не участвует в этом шаблоне": "não participa deste modelo",
    "от {0} до {1}": "de {0} a {1}",
    "от {0} до {1} фото": "de {0} a {1} fotos",
    "от {0} до {1} фото{2}": "de {0} a {1} fotos{2}",
    "по {0}": "{0} cada",
    "по {0} варианта каждого шаблона": "{0} opções de cada modelo",
    "по сюжету каждого шаблона": "pela história de cada modelo",
    "рилс": "reel",
    "рилс не создан": "o reel não foi criado",
    "рилса": "reels",
    "рилсов": "reels",
    "рилсы": "os reels",
    "роликов": "vídeos",
    "стиль «{0}»": "estilo “{0}”",
    "товара": "do produto",
    "фото {0} из {1}": "foto {0} de {1}",
    "шаблон": "modelo",
    "шаблона": "modelos",
    "шаблонах": "modelos",
    "шаблоне": "modelo",
    "шаблонов": "modelos",
    "1 ролик": "1 vídeo",
    "По одному ролику": "Um vídeo cada",
    "По одному ролику каждого шаблона": "Um vídeo de cada modelo",
    "Один ролик в заказе": "Um vídeo por pedido",
    "У каждого по одному ролику.": "Cada um tem um vídeo.",
    "Собираем ролик": "Montando o vídeo",
    "за ролик": "por vídeo",
    "Снимаем сцену": "Filmando a cena",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Você pode sair da tela: o bot enviará o vídeo pronto para o chat.",
    "Ролик готов": "Vídeo pronto",
    "Бот уже прислал его в чат, в отдельную тему.": "O bot já o enviou para o chat, num tópico separado."
  },
  "tr": {
    "{0} {1} готовы": "{0} {1} hazır",
    "{0} варианта в заказе": "Siparişte {0} seçenek",
    "{0} и ещё {1}": "{0} ve {1} kişi daha",
    "{0} разных рилсов": "{0} farklı reel",
    "{0} разных сюжетов с вами за один заказ": "Tek siparişte sizinle {0} farklı hikâye",
    "{0} рилсов сразу": "Tek seferde {0} reel",
    "{0} фото{1}": "{0} fotoğraf{1}",
    "· скидка {0}": "· {0} indirim",
    "Блюдо крупно, при дневном свете": "Yemek yakından, gün ışığında",
    "Бот уже прислал их в чат, в отдельную тему.": "Bot bunları zaten sohbete, ayrı bir konuya gönderdi.",
    "В рилс войдут первые {0} фото": "Reele ilk {0} fotoğraf girecek",
    "Варианты собраны": "Seçenekler hazır",
    "Во всех шаблонах": "Tüm şablonlarda",
    "Вы в истории шаблона «{0}»": "“{0}” şablonunun hikâyesinde siz",
    "Вы в кадре": "Karedesiniz",
    "Вы в кино": "Sinemada siz",
    "Вы в сюжете": "Siz hikâyedesiniz",
    "Выберите, кто в кадре": "Karede kimin olacağını seçin",
    "Выбрать несколько шаблонов": "Birkaç şablon seç",
    "Главный герой": "Başrol",
    "Дальше": "İleri",
    "Дальше ·": "İleri ·",
    "Десять разных сюжетов с вами за один заказ": "Tek siparişte sizinle on farklı hikâye",
    "Для этого ряда ещё варианты недоступны": "Bu satır için başka seçenek yok",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "{1} fotoğraftan {0} tanesi eklendi: şablon en fazla {2} fotoğraf alır",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "Ek sipariş onaylanmadı. Tekrar dokunmak aynı isteği kontrol eder.",
    "Другой шаблон": "Başka şablon",
    "Ещё 3 варианта": "3 seçenek daha",
    "Ещё варианты можно добавить в конце ряда.": "Satırın sonunda daha fazla seçenek ekleyebilirsiniz.",
    "Загружаем фото": "Fotoğraflar yükleniyor",
    "Загрузите {0} фото{1}": "{0} fotoğraf{1} yükleyin",
    "Загрузите ещё {0} фото{1}": "{0} fotoğraf{1} daha yükleyin",
    "Загрузите фото{0}": "Fotoğraf{0} yükleyin",
    "Заменить фото": "Fotoğrafı değiştir",
    "Играет в шаблонах: {0}": "Oynadığı şablonlar: {0}",
    "Камера · снимки подряд": "Kamera · art arda çekim",
    "Кто будет в истории шаблона": "Şablonun hikâyesinde kim olacak",
    "Кто будет во всех десяти роликах": "On videonun hepsinde kim olacak",
    "Люди в сюжете": "Kişiler hikâyede",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Ekrandan çıkabilirsiniz: bot hazır videoları sohbete gönderecek.",
    "Монтаж и музыка": "Kurgu ve müzik",
    "Музыка и монтаж из шаблона": "Müzik ve kurgu şablondan",
    "Музыка и монтаж уже в шаблоне": "Müzik ve kurgu zaten şablonda",
    "Нажмите, чтобы открыть шаблон": "Şablonu açmak için dokunun",
    "Нажмите, чтобы отметить шаблон": "Şablonu işaretlemek için dokunun",
    "Не получилось собрать рилс": "Reel oluşturulamadı",
    "Не хватает Circle. Пополните баланс": "Yeterli Circle yok. Bakiyenizi yükleyin",
    "Не хватает {0} C. Пополните баланс": "{0} C eksik. Bakiyenizi yükleyin",
    "От трёх шаблонов скидка 20%": "Üç şablondan itibaren %20 indirim",
    "Открыть шаблон": "Şablonu aç",
    "Отметить": "İşaretle",
    "Отметьте ещё один шаблон": "Bir şablon daha işaretleyin",
    "Отметьте шаблоны": "Şablonları işaretleyin",
    "Отметьте шаблоны: от трёх скидка 20%": "Şablonları işaretleyin: üç ve üzeri %20 indirim",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Paket ayrı hazırlanır: içinde zaten 10 reel var",
    "По {0} варианта": "Her biri {0} seçenek",
    "Пример:": "Örnek:",
    "Рилс с вами": "Sizinle reels",
    "Рилсы собраны": "Reeller hazır",
    "Роль «{0}» пока недоступна": "“{0}” rolü henüz kullanılamıyor",
    "Светлые кадры, каждое место целиком": "Aydınlık kareler, her mekân bütünüyle",
    "Скидка 20% за набор": "Set için %20 indirim",
    "Смонтировано": "Kurgulandı",
    "Смотреть:": "İzle:",
    "Снимаем сцены": "Sahneler çekiliyor",
    "Снять отметку": "İşareti kaldır",
    "Собираем": "Hazırlanıyor",
    "Собираем {0} {1}": "{0} {1} hazırlanıyor",
    "Собираем рилс": "Reel hazırlanıyor",
    "Собираем рилсы": "Reeller hazırlanıyor",
    "Создать {0} {1} · {2}": "{0} {1} oluştur · {2}",
    "Создать {0} рилсов · {1}": "{0} reel oluştur · {1}",
    "Создать · {0}": "Oluştur · {0}",
    "Ставим вас в сюжет": "Sizi hikâyeye yerleştiriyoruz",
    "Ставим людей в сюжет": "Kişileri hikâyeye yerleştiriyoruz",
    "Стиль «{0}» ·": "“{0}” stili ·",
    "Сцены сняты": "Sahneler çekildi",
    "Товар целиком, на чистом фоне, без надписей": "Ürünün tamamı, düz arka planda, yazısız",
    "Только для этого рилса": "Yalnızca bu reel için",
    "Тут откроется тема чата, куда бот прислал рилсы": "Burada botun reelleri gönderdiği sohbet konusu açılacak",
    "У каждого по {0} варианта.": "Her birinin {0} seçeneği var.",
    "Удалить из рилса": "Reelden kaldır",
    "Удерживайте, чтобы посмотреть пример": "Örneği görmek için basılı tutun",
    "Фото блюда": "Yemek fotoğrafları",
    "Фото загружены": "Fotoğraflar yüklendi",
    "Фото места": "Mekân fotoğrafları",
    "Фото не прошли проверку": "Fotoğraflar kontrolden geçmedi",
    "Чёткие снимки: лица и детали хорошо видно": "Net kareler: yüzler ve ayrıntılar iyi görünüyor",
    "Шаблон «{0}»": "«{0}» şablonu",
    "Шаблон берёт до {0} фото": "Şablon en fazla {0} fotoğraf alır",
    "Шаблоны в заказе": "Siparişteki şablonlar",
    "Этот вариант рилса пока недоступен": "Bu reel seçeneği henüz kullanılamıyor",
    "блюда": "yemeğin",
    "в работе": "hazırlanıyor",
    "вариант": "seçenek",
    "варианта": "seçenek",
    "вариантов": "seçenek",
    "вместо": "yerine",
    "до / после": "önce / sonra",
    "до {0} фото": "en fazla {0} fotoğraf",
    "до {0} фото{1}": "en fazla {0} fotoğraf{1}",
    "из рилса": "reelden",
    "из шаблона": "şablondan",
    "из этого рилса": "bu reelden",
    "места": "mekânın",
    "музыка и монтаж уже в": "müzik ve kurgu zaten",
    "не участвует в этом шаблоне": "bu şablonda yer almıyor",
    "от {0} до {1}": "{0}–{1}",
    "от {0} до {1} фото": "{0}–{1} fotoğraf",
    "от {0} до {1} фото{2}": "{0}–{1} fotoğraf{2}",
    "по {0}": "her biri {0}",
    "по {0} варианта каждого шаблона": "her şablondan {0} seçenek",
    "по сюжету каждого шаблона": "her şablonun hikâyesine göre",
    "рилс": "reel",
    "рилс не создан": "reel oluşturulmadı",
    "рилса": "reel",
    "рилсов": "reel",
    "рилсы": "reelleri",
    "роликов": "video",
    "стиль «{0}»": "“{0}” stili",
    "товара": "ürünün",
    "фото {0} из {1}": "fotoğraf {0}/{1}",
    "шаблон": "şablon",
    "шаблона": "şablon",
    "шаблонах": "şablonlarda",
    "шаблоне": "şablonda",
    "шаблонов": "şablon",
    "1 ролик": "1 video",
    "По одному ролику": "Birer video",
    "По одному ролику каждого шаблона": "Her şablondan bir video",
    "Один ролик в заказе": "Sipariş başına bir video",
    "У каждого по одному ролику.": "Her birinde bir video var.",
    "Собираем ролик": "Video birleştiriliyor",
    "за ролик": "video başına",
    "Снимаем сцену": "Sahne çekiliyor",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Ekrandan çıkabilirsiniz: bot hazır videoyu sohbete gönderecek.",
    "Ролик готов": "Video hazır",
    "Бот уже прислал его в чат, в отдельную тему.": "Bot onu sohbete, ayrı bir konuya zaten gönderdi."
  },
  "kk": {
    "{0} {1} готовы": "{0} {1} дайын",
    "{0} варианта в заказе": "Тапсырыста {0} нұсқа",
    "{0} и ещё {1}": "{0} және тағы {1}",
    "{0} разных рилсов": "{0} түрлі рилс",
    "{0} разных сюжетов с вами за один заказ": "Бір тапсырыста сізбен {0} түрлі сюжет",
    "{0} рилсов сразу": "Бірден {0} рилс",
    "{0} фото{1}": "{0} фото{1}",
    "· скидка {0}": "· {0} жеңілдік",
    "Блюдо крупно, при дневном свете": "Тағам жақыннан, күндізгі жарықта",
    "Бот уже прислал их в чат, в отдельную тему.": "Бот оларды чатқа жеке тақырыпқа жіберіп қойды.",
    "В рилс войдут первые {0} фото": "Рилске алғашқы {0} фото кіреді",
    "Варианты собраны": "Нұсқалар жиналды",
    "Во всех шаблонах": "Барлық үлгілерде",
    "Вы в истории шаблона «{0}»": "«{0}» үлгісінің оқиғасында сіз",
    "Вы в кадре": "Сіз кадрдасыз",
    "Вы в кино": "Сіз кинода",
    "Вы в сюжете": "Сіз сюжеттесіз",
    "Выберите, кто в кадре": "Кадрда кім болатынын таңдаңыз",
    "Выбрать несколько шаблонов": "Бірнеше үлгі таңдау",
    "Главный герой": "Басты кейіпкер",
    "Дальше": "Әрі қарай",
    "Дальше ·": "Әрі қарай ·",
    "Десять разных сюжетов с вами за один заказ": "Бір тапсырыста сізбен он түрлі сюжет",
    "Для этого ряда ещё варианты недоступны": "Бұл қатар үшін қосымша нұсқалар қолжетімсіз",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "{1} фотодан {0} қосылды: үлгі {2} фотоға дейін алады",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "Қосымша тапсырыс расталмады. Қайта басу сол сұрауды тексереді.",
    "Другой шаблон": "Басқа үлгі",
    "Ещё 3 варианта": "Тағы 3 нұсқа",
    "Ещё варианты можно добавить в конце ряда.": "Қатардың соңында қосымша нұсқалар қоса аласыз.",
    "Загружаем фото": "Фото жүктеліп жатыр",
    "Загрузите {0} фото{1}": "{0} фото{1} жүктеңіз",
    "Загрузите ещё {0} фото{1}": "Тағы {0} фото{1} жүктеңіз",
    "Загрузите фото{0}": "Фото{0} жүктеңіз",
    "Заменить фото": "Фотоны ауыстыру",
    "Играет в шаблонах: {0}": "Ойнайтын үлгілер: {0}",
    "Камера · снимки подряд": "Камера · қатарынан түсіру",
    "Кто будет в истории шаблона": "Үлгі оқиғасында кім болады",
    "Кто будет во всех десяти роликах": "Он роликтің бәрінде кім болады",
    "Люди в сюжете": "Адамдар сюжетте",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Экраннан шыға беруге болады: бот дайын роликтерді чатқа жібереді.",
    "Монтаж и музыка": "Монтаж және музыка",
    "Музыка и монтаж из шаблона": "Музыка мен монтаж үлгіден",
    "Музыка и монтаж уже в шаблоне": "Музыка мен монтаж үлгіде бар",
    "Нажмите, чтобы открыть шаблон": "Үлгіні ашу үшін басыңыз",
    "Нажмите, чтобы отметить шаблон": "Үлгіні белгілеу үшін басыңыз",
    "Не получилось собрать рилс": "Рилсті жасау мүмкін болмады",
    "Не хватает Circle. Пополните баланс": "Circle жеткіліксіз. Балансты толтырыңыз",
    "Не хватает {0} C. Пополните баланс": "{0} C жетпейді. Балансты толтырыңыз",
    "От трёх шаблонов скидка 20%": "Үш үлгіден бастап 20% жеңілдік",
    "Открыть шаблон": "Үлгіні ашу",
    "Отметить": "Белгілеу",
    "Отметьте ещё один шаблон": "Тағы бір үлгі белгілеңіз",
    "Отметьте шаблоны": "Үлгілерді белгілеңіз",
    "Отметьте шаблоны: от трёх скидка 20%": "Үлгілерді белгілеңіз: үшеуінен бастап 20% жеңілдік",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Пакет бөлек жиналады: онда 10 рилс бар",
    "По {0} варианта": "Әрқайсысы {0} нұсқа",
    "Пример:": "Мысал:",
    "Рилс с вами": "Сізбен рилс",
    "Рилсы собраны": "Рилстер жиналды",
    "Роль «{0}» пока недоступна": "«{0}» рөлі әзірге қолжетімсіз",
    "Светлые кадры, каждое место целиком": "Жарық кадрлар, әр орын толық",
    "Скидка 20% за набор": "Жиынтыққа 20% жеңілдік",
    "Смонтировано": "Монтаждалды",
    "Смотреть:": "Көру:",
    "Снимаем сцены": "Сахналар түсірілуде",
    "Снять отметку": "Белгіні алу",
    "Собираем": "Жиналуда",
    "Собираем {0} {1}": "{0} {1} жиналуда",
    "Собираем рилс": "Рилс жиналуда",
    "Собираем рилсы": "Рилстер жиналуда",
    "Создать {0} {1} · {2}": "{0} {1} жасау · {2}",
    "Создать {0} рилсов · {1}": "{0} рилс жасау · {1}",
    "Создать · {0}": "Жасау · {0}",
    "Ставим вас в сюжет": "Сізді сюжетке қосып жатырмыз",
    "Ставим людей в сюжет": "Адамдарды сюжетке қосып жатырмыз",
    "Стиль «{0}» ·": "«{0}» стилі ·",
    "Сцены сняты": "Сахналар түсірілді",
    "Товар целиком, на чистом фоне, без надписей": "Тауар толық, таза фонда, жазусыз",
    "Только для этого рилса": "Тек осы рилс үшін",
    "Тут откроется тема чата, куда бот прислал рилсы": "Мұнда бот рилстерді жіберген чат тақырыбы ашылады",
    "У каждого по {0} варианта.": "Әрқайсысында {0} нұсқа бар.",
    "Удалить из рилса": "Рилстен алып тастау",
    "Удерживайте, чтобы посмотреть пример": "Мысалды көру үшін басып тұрыңыз",
    "Фото блюда": "Тағам фотолары",
    "Фото загружены": "Фотолар жүктелді",
    "Фото места": "Орын фотолары",
    "Фото не прошли проверку": "Фотолар тексерістен өтпеді",
    "Чёткие снимки: лица и детали хорошо видно": "Анық кадрлар: беттер мен бөлшектер жақсы көрінеді",
    "Шаблон «{0}»": "«{0}» үлгісі",
    "Шаблон берёт до {0} фото": "Үлгі {0} фотоға дейін алады",
    "Шаблоны в заказе": "Тапсырыстағы үлгілер",
    "Этот вариант рилса пока недоступен": "Рилстің бұл нұсқасы әзірге қолжетімсіз",
    "блюда": "тағамның",
    "в работе": "жасалуда",
    "вариант": "нұсқа",
    "варианта": "нұсқа",
    "вариантов": "нұсқа",
    "вместо": "орнына",
    "до / после": "дейін / кейін",
    "до {0} фото": "{0} фотоға дейін",
    "до {0} фото{1}": "{0} фото{1} дейін",
    "из рилса": "рилстен",
    "из шаблона": "үлгіден",
    "из этого рилса": "осы рилстен",
    "места": "орынның",
    "музыка и монтаж уже в": "музыка мен монтаж дайын:",
    "не участвует в этом шаблоне": "бұл үлгіге қатыспайды",
    "от {0} до {1}": "{0}–{1}",
    "от {0} до {1} фото": "{0}–{1} фото",
    "от {0} до {1} фото{2}": "{0}–{1} фото{2}",
    "по {0}": "әрқайсысы {0}",
    "по {0} варианта каждого шаблона": "әр үлгіден {0} нұсқа",
    "по сюжету каждого шаблона": "әр үлгінің сюжеті бойынша",
    "рилс": "рилс",
    "рилс не создан": "рилс жасалмады",
    "рилса": "рилс",
    "рилсов": "рилс",
    "рилсы": "рилстерді",
    "роликов": "ролик",
    "стиль «{0}»": "«{0}» стилі",
    "товара": "тауардың",
    "фото {0} из {1}": "фото {0}/{1}",
    "шаблон": "үлгі",
    "шаблона": "үлгі",
    "шаблонах": "үлгілерде",
    "шаблоне": "үлгіде",
    "шаблонов": "үлгі",
    "1 ролик": "1 бейне",
    "По одному ролику": "Бір-бір бейнеден",
    "По одному ролику каждого шаблона": "Әр үлгіден бір бейне",
    "Один ролик в заказе": "Тапсырыста бір бейне",
    "У каждого по одному ролику.": "Әрқайсысында бір бейне.",
    "Собираем ролик": "Ролик құрастырылуда",
    "за ролик": "бір бейне үшін",
    "Снимаем сцену": "Көріністі түсіріп жатырмыз",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Экраннан шығуға болады: бот дайын бейнені чатқа жібереді.",
    "Ролик готов": "Бейне дайын",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот оны чатқа, жеке тақырыпқа жіберіп қойды."
  },
  "uk": {
    "{0} {1} готовы": "{0} {1} готові",
    "{0} варианта в заказе": "{0} варіанти в замовленні",
    "{0} и ещё {1}": "{0} і ще {1}",
    "{0} разных рилсов": "{0} різних рилсів",
    "{0} разных сюжетов с вами за один заказ": "{0} різних сюжетів з вами за одне замовлення",
    "{0} рилсов сразу": "{0} рилсів одразу",
    "{0} фото{1}": "{0} фото{1}",
    "· скидка {0}": "· знижка {0}",
    "Блюдо крупно, при дневном свете": "Страва крупним планом, при денному світлі",
    "Бот уже прислал их в чат, в отдельную тему.": "Бот уже надіслав їх у чат, в окрему тему.",
    "В рилс войдут первые {0} фото": "До рилса увійдуть перші {0} фото",
    "Варианты собраны": "Варіанти зібрано",
    "Во всех шаблонах": "У всіх шаблонах",
    "Вы в истории шаблона «{0}»": "Ви в історії шаблону «{0}»",
    "Вы в кадре": "Ви в кадрі",
    "Вы в кино": "Ви в кіно",
    "Вы в сюжете": "Ви в сюжеті",
    "Выберите, кто в кадре": "Виберіть, хто в кадрі",
    "Выбрать несколько шаблонов": "Вибрати кілька шаблонів",
    "Главный герой": "Головний герой",
    "Дальше": "Далі",
    "Дальше ·": "Далі ·",
    "Десять разных сюжетов с вами за один заказ": "Десять різних сюжетів з вами за одне замовлення",
    "Для этого ряда ещё варианты недоступны": "Для цього ряду більше варіантів немає",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "Додано {0} з {1}: шаблон бере до {2} фото",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "Дозамовлення не підтверджено. Повторне натискання перевірить той самий запит.",
    "Другой шаблон": "Інший шаблон",
    "Ещё 3 варианта": "Ще 3 варіанти",
    "Ещё варианты можно добавить в конце ряда.": "Більше варіантів можна додати в кінці ряду.",
    "Загружаем фото": "Завантажуємо фото",
    "Загрузите {0} фото{1}": "Завантажте {0} фото{1}",
    "Загрузите ещё {0} фото{1}": "Завантажте ще {0} фото{1}",
    "Загрузите фото{0}": "Завантажте фото{0}",
    "Заменить фото": "Замінити фото",
    "Играет в шаблонах: {0}": "Грає в шаблонах: {0}",
    "Камера · снимки подряд": "Камера · знімки поспіль",
    "Кто будет в истории шаблона": "Хто буде в історії шаблону",
    "Кто будет во всех десяти роликах": "Хто буде в усіх десяти роликах",
    "Люди в сюжете": "Люди в сюжеті",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "Можна вийти з екрана: бот надішле готові ролики в чат.",
    "Монтаж и музыка": "Монтаж і музика",
    "Музыка и монтаж из шаблона": "Музика й монтаж із шаблону",
    "Музыка и монтаж уже в шаблоне": "Музика й монтаж уже в шаблоні",
    "Нажмите, чтобы открыть шаблон": "Натисніть, щоб відкрити шаблон",
    "Нажмите, чтобы отметить шаблон": "Натисніть, щоб позначити шаблон",
    "Не получилось собрать рилс": "Не вдалося зібрати рилс",
    "Не хватает Circle. Пополните баланс": "Недостатньо Circle. Поповніть баланс",
    "Не хватает {0} C. Пополните баланс": "Бракує {0} C. Поповніть баланс",
    "От трёх шаблонов скидка 20%": "Від трьох шаблонів знижка 20%",
    "Открыть шаблон": "Відкрити шаблон",
    "Отметить": "Позначити",
    "Отметьте ещё один шаблон": "Позначте ще один шаблон",
    "Отметьте шаблоны": "Позначте шаблони",
    "Отметьте шаблоны: от трёх скидка 20%": "Позначте шаблони: від трьох знижка 20%",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "Пакет збирається окремо: у ньому вже 10 рилсів",
    "По {0} варианта": "По {0} варіанти",
    "Пример:": "Приклад:",
    "Рилс с вами": "Рилс з вами",
    "Рилсы собраны": "Рилси зібрано",
    "Роль «{0}» пока недоступна": "Роль «{0}» поки недоступна",
    "Светлые кадры, каждое место целиком": "Світлі кадри, кожне місце повністю",
    "Скидка 20% за набор": "Знижка 20% за набір",
    "Смонтировано": "Змонтовано",
    "Смотреть:": "Дивитися:",
    "Снимаем сцены": "Знімаємо сцени",
    "Снять отметку": "Зняти позначку",
    "Собираем": "Збираємо",
    "Собираем {0} {1}": "Збираємо {0} {1}",
    "Собираем рилс": "Збираємо рилс",
    "Собираем рилсы": "Збираємо рилси",
    "Создать {0} {1} · {2}": "Створити {0} {1} · {2}",
    "Создать {0} рилсов · {1}": "Створити {0} рилсів · {1}",
    "Создать · {0}": "Створити · {0}",
    "Ставим вас в сюжет": "Ставимо вас у сюжет",
    "Ставим людей в сюжет": "Ставимо людей у сюжет",
    "Стиль «{0}» ·": "Стиль «{0}» ·",
    "Сцены сняты": "Сцени знято",
    "Товар целиком, на чистом фоне, без надписей": "Товар повністю, на чистому тлі, без написів",
    "Только для этого рилса": "Лише для цього рилса",
    "Тут откроется тема чата, куда бот прислал рилсы": "Тут відкриється тема чату, куди бот надіслав рилси",
    "У каждого по {0} варианта.": "У кожного по {0} варіанти.",
    "Удалить из рилса": "Видалити з рилса",
    "Удерживайте, чтобы посмотреть пример": "Утримуйте, щоб переглянути приклад",
    "Фото блюда": "Фото страви",
    "Фото загружены": "Фото завантажено",
    "Фото места": "Фото місця",
    "Фото не прошли проверку": "Фото не пройшли перевірку",
    "Чёткие снимки: лица и детали хорошо видно": "Чіткі знімки: обличчя й деталі добре видно",
    "Шаблон «{0}»": "Шаблон «{0}»",
    "Шаблон берёт до {0} фото": "Шаблон бере до {0} фото",
    "Шаблоны в заказе": "Шаблони в замовленні",
    "Этот вариант рилса пока недоступен": "Цей варіант рилса поки недоступний",
    "блюда": "страви",
    "в работе": "у роботі",
    "вариант": "варіант",
    "варианта": "варіанти",
    "вариантов": "варіантів",
    "вместо": "замість",
    "до / после": "до / після",
    "до {0} фото": "до {0} фото",
    "до {0} фото{1}": "до {0} фото{1}",
    "из рилса": "з рилса",
    "из шаблона": "із шаблону",
    "из этого рилса": "з цього рилса",
    "места": "місця",
    "музыка и монтаж уже в": "музика й монтаж уже в",
    "не участвует в этом шаблоне": "не бере участі в цьому шаблоні",
    "от {0} до {1}": "від {0} до {1}",
    "от {0} до {1} фото": "від {0} до {1} фото",
    "от {0} до {1} фото{2}": "від {0} до {1} фото{2}",
    "по {0}": "по {0}",
    "по {0} варианта каждого шаблона": "по {0} варіанти кожного шаблону",
    "по сюжету каждого шаблона": "за сюжетом кожного шаблону",
    "рилс": "рилс",
    "рилс не создан": "рилс не створено",
    "рилса": "рилси",
    "рилсов": "рилсів",
    "рилсы": "рилси",
    "роликов": "роликів",
    "стиль «{0}»": "стиль «{0}»",
    "товара": "товару",
    "фото {0} из {1}": "фото {0} з {1}",
    "шаблон": "шаблон",
    "шаблона": "шаблони",
    "шаблонах": "шаблонах",
    "шаблоне": "шаблоні",
    "шаблонов": "шаблонів",
    "1 ролик": "1 відео",
    "По одному ролику": "По одному відео",
    "По одному ролику каждого шаблона": "По одному відео кожного шаблону",
    "Один ролик в заказе": "Одне відео в замовленні",
    "У каждого по одному ролику.": "У кожного по одному відео.",
    "Собираем ролик": "Збираємо ролик",
    "за ролик": "за відео",
    "Снимаем сцену": "Знімаємо сцену",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "Можна піти з екрана: бот надішле готове відео в чат.",
    "Ролик готов": "Відео готове",
    "Бот уже прислал его в чат, в отдельную тему.": "Бот уже надіслав його в чат, в окрему тему."
  },
  "zh": {
    "{0} {1} готовы": "{0} {1}已完成",
    "{0} варианта в заказе": "每单 {0} 个版本",
    "{0} и ещё {1}": "{0} 等 {1} 个",
    "{0} разных рилсов": "{0} 个不同的 Reels",
    "{0} разных сюжетов с вами за один заказ": "一单生成 {0} 个由你主演的不同故事",
    "{0} рилсов сразу": "一次 {0} 个 Reels",
    "{0} фото{1}": "{0} 张照片{1}",
    "· скидка {0}": "· 优惠 {0}",
    "Блюдо крупно, при дневном свете": "菜品特写，自然光",
    "Бот уже прислал их в чат, в отдельную тему.": "机器人已把它们发到聊天的单独话题中。",
    "В рилс войдут первые {0} фото": "Reels 将使用前 {0} 张照片",
    "Варианты собраны": "版本已合成",
    "Во всех шаблонах": "所有模板中",
    "Вы в истории шаблона «{0}»": "你在模板「{0}」的故事里",
    "Вы в кадре": "你在画面中",
    "Вы в кино": "你在电影里",
    "Вы в сюжете": "你在故事里",
    "Выберите, кто в кадре": "选择画面中的人",
    "Выбрать несколько шаблонов": "选择多个模板",
    "Главный герой": "主角",
    "Дальше": "下一步",
    "Дальше ·": "下一步 ·",
    "Десять разных сюжетов с вами за один заказ": "一单生成十个由你主演的不同故事",
    "Для этого ряда ещё варианты недоступны": "此行暂无更多版本",
    "Добавили {0} из {1}: шаблон берёт до {2} фото": "已添加 {0} / {1}：模板最多使用 {2} 张照片",
    "Дозаказ не подтверждён. Повторное нажатие проверит тот же запрос.": "追加订单未确认。再次点击将检查同一请求。",
    "Другой шаблон": "其他模板",
    "Ещё 3 варианта": "再来 3 个版本",
    "Ещё варианты можно добавить в конце ряда.": "可以在行末添加更多版本。",
    "Загружаем фото": "正在上传照片",
    "Загрузите {0} фото{1}": "上传 {0} 张照片{1}",
    "Загрузите ещё {0} фото{1}": "再上传 {0} 张照片{1}",
    "Загрузите фото{0}": "上传照片{0}",
    "Заменить фото": "替换照片",
    "Играет в шаблонах: {0}": "出演模板：{0}",
    "Камера · снимки подряд": "相机 · 连拍",
    "Кто будет в истории шаблона": "谁出现在模板的故事里",
    "Кто будет во всех десяти роликах": "谁出现在全部十个视频里",
    "Люди в сюжете": "故事中有人物",
    "Можно уйти с экрана: бот пришлёт готовые ролики в чат.": "可以离开此页面：机器人会把完成的视频发到聊天中。",
    "Монтаж и музыка": "剪辑和音乐",
    "Музыка и монтаж из шаблона": "模板自带音乐和剪辑",
    "Музыка и монтаж уже в шаблоне": "模板已包含音乐和剪辑",
    "Нажмите, чтобы открыть шаблон": "点击打开模板",
    "Нажмите, чтобы отметить шаблон": "点击选中模板",
    "Не получилось собрать рилс": "Reels 生成失败",
    "Не хватает Circle. Пополните баланс": "Circle 不足，请充值",
    "Не хватает {0} C. Пополните баланс": "还差 {0} C，请充值",
    "От трёх шаблонов скидка 20%": "选三个模板起享 8 折",
    "Открыть шаблон": "打开模板",
    "Отметить": "选中",
    "Отметьте ещё один шаблон": "再选一个模板",
    "Отметьте шаблоны": "选中模板",
    "Отметьте шаблоны: от трёх скидка 20%": "选中模板：三个起享 8 折",
    "Пакет собирается отдельно: в нём уже 10 рилсов": "套装单独制作：已包含 10 个 Reels",
    "По {0} варианта": "每个 {0} 个版本",
    "Пример:": "示例：",
    "Рилс с вами": "有你的 Reels",
    "Рилсы собраны": "Reels 已合成",
    "Роль «{0}» пока недоступна": "角色「{0}」暂不可用",
    "Светлые кадры, каждое место целиком": "明亮的画面，完整展现每个地点",
    "Скидка 20% за набор": "套装享 8 折",
    "Смонтировано": "已剪辑",
    "Смотреть:": "观看：",
    "Снимаем сцены": "正在拍摄场景",
    "Снять отметку": "取消选中",
    "Собираем": "正在合成",
    "Собираем {0} {1}": "正在合成 {0} 个{1}",
    "Собираем рилс": "正在制作 Reels",
    "Собираем рилсы": "正在制作 Reels",
    "Создать {0} {1} · {2}": "创建 {0} 个{1} · {2}",
    "Создать {0} рилсов · {1}": "创建 {0} 个 Reels · {1}",
    "Создать · {0}": "创建 · {0}",
    "Ставим вас в сюжет": "正在把你放进故事",
    "Ставим людей в сюжет": "正在把人物放进故事",
    "Стиль «{0}» ·": "风格「{0}」·",
    "Сцены сняты": "场景已拍完",
    "Товар целиком, на чистом фоне, без надписей": "完整商品，纯色背景，无文字",
    "Только для этого рилса": "仅用于此 Reels",
    "Тут откроется тема чата, куда бот прислал рилсы": "这里会打开机器人发送 Reels 的聊天话题",
    "У каждого по {0} варианта.": "每个有 {0} 个版本。",
    "Удалить из рилса": "从 Reels 中移除",
    "Удерживайте, чтобы посмотреть пример": "长按查看示例",
    "Фото блюда": "菜品照片",
    "Фото загружены": "照片已上传",
    "Фото места": "地点照片",
    "Фото не прошли проверку": "照片未通过审核",
    "Чёткие снимки: лица и детали хорошо видно": "清晰照片：面部和细节清楚可见",
    "Шаблон «{0}»": "模板「{0}」",
    "Шаблон берёт до {0} фото": "模板最多使用 {0} 张照片",
    "Шаблоны в заказе": "订单中的模板",
    "Этот вариант рилса пока недоступен": "此 Reels 版本暂不可用",
    "блюда": "菜品",
    "в работе": "处理中",
    "вариант": "版本",
    "варианта": "版本",
    "вариантов": "版本",
    "вместо": "替代",
    "до / после": "前 / 后",
    "до {0} фото": "最多 {0} 张照片",
    "до {0} фото{1}": "最多 {0} 张照片{1}",
    "из рилса": "从 Reels 中",
    "из шаблона": "来自模板",
    "из этого рилса": "从此 Reels 中",
    "места": "地点",
    "музыка и монтаж уже в": "音乐和剪辑已包含在",
    "не участвует в этом шаблоне": "不参与此模板",
    "от {0} до {1}": "{0} 到 {1}",
    "от {0} до {1} фото": "{0} 到 {1} 张照片",
    "от {0} до {1} фото{2}": "{0} 到 {1} 张照片{2}",
    "по {0}": "每个 {0}",
    "по {0} варианта каждого шаблона": "每个模板 {0} 个版本",
    "по сюжету каждого шаблона": "按每个模板的故事",
    "рилс": "Reels",
    "рилс не создан": "Reels 未生成",
    "рилса": "Reels",
    "рилсов": "Reels",
    "рилсы": "Reels",
    "роликов": "视频",
    "стиль «{0}»": "风格「{0}」",
    "товара": "商品",
    "фото {0} из {1}": "照片 {0} / {1}",
    "шаблон": "个模板",
    "шаблона": "个模板",
    "шаблонах": "模板",
    "шаблоне": "模板",
    "шаблонов": "个模板",
    "1 ролик": "1 个视频",
    "По одному ролику": "每个一个视频",
    "По одному ролику каждого шаблона": "每个模板一个视频",
    "Один ролик в заказе": "每单一个视频",
    "У каждого по одному ролику.": "每个一个视频。",
    "Собираем ролик": "正在合成视频",
    "за ролик": "每个视频",
    "Снимаем сцену": "正在拍摄场景",
    "Можно уйти с экрана: бот пришлёт готовый ролик в чат.": "可以离开此页面：机器人会把完成的视频发到聊天中。",
    "Ролик готов": "视频已完成",
    "Бот уже прислал его в чат, в отдельную тему.": "机器人已把它发到聊天的单独话题中。"
  }
}
